import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "category-nav" }
const _hoisted_2 = { class: "category-icon" }
const _hoisted_3 = { class: "category-name" }
const _hoisted_4 = { class: "promo-section" }
const _hoisted_5 = { class: "promo-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "promo-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "promo-info" }
const _hoisted_10 = { class: "promo-title" }
const _hoisted_11 = { class: "promo-price" }
const _hoisted_12 = { class: "promo-section" }
const _hoisted_13 = { class: "promo-grid" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "promo-img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "promo-info" }
const _hoisted_18 = { class: "promo-title" }
const _hoisted_19 = { class: "promo-price" }
const _hoisted_20 = { class: "ranking-section" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "promo-img" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "ranking-info" }
const _hoisted_25 = { class: "ranking-title" }
const _hoisted_26 = { class: "ranking-price" }

import { Options, Vue } from 'vue-class-component';

import { createApp, ref, computed, watch, onMounted } from "vue";
import Layfooter from '@/components/lay-footer/index.vue';
import { ShopTypeEmun } from '@/httpRequest/ShopEmun';
import { GetListBusinessCategory, Productlist } from '@/httpRequest/ProductRequest';
import { useRouter } from "vue-router/dist/vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
// const categories = ref([


//   { id: 3, categeroyName: '手机数码', icon: '📱' },


//     { id: 7, categeroyName: '美妆饰品', icon: '💄' },
//      { id: 8, categeroyName: '家用电器', icon: '🏠' },
//       { id: 9, categeroyName: '服装鞋包', icon: '👜' },
//        { id: 10, categeroyName: '其他商品', icon: '🔄' },

// ])
const categories = ref([])

const newProducts = ref([])
const rankingList = ref([])
const hotProducts = ref([])
onMounted(async () => {

    GetListBusinessCategoryData(2112010);
    newProductsData();
    rankingListData();
    hotProductsData();
    // initializeTableHead()
    // skuList.value[0].values.push('绿色')


});

const newProductsData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7becb2afebf72e045434ddb51cb14906"
    });
    newProducts.value = listInfo.data.list;
    console.log("newProducts" + newProducts.value)
};

const rankingListData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7bedef9fefc4b0b27ce072d87bc079a8"
    });
    rankingList.value = listInfo.data.list;

};

const hotProductsData = async () => {

    var listInfo = await Productlist({
        pageIndex: 1,
        pageSize: 8,
        shopTypeStatus: ShopTypeEmun.OnlineStore,
        productsToShopId: "7bedfe65bca111fd0d65d47169dfa5e9"
    });
    hotProducts.value = listInfo.data.list;
    console.log("hotProducts" + hotProducts.value)
};


const GetListBusinessCategoryData = async (data: any) => {
    var resd = await GetListBusinessCategory({
        shopTypeStatus: data,
        location: 1
    });
    console.log("resd" + resd.status)
    if (resd.status == true) {


        categories.value = resd.data.list


    }
    else {

    }


};

const viewProduct = (product: any) => {
    router.push(`/products/ProductsDetails?id=${product.id}`)
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"header\" data-v-71686590><div class=\"search-bar\" data-v-71686590><span data-v-71686590>🔍</span><input type=\"text\" placeholder=\"请输入关键词\" data-v-71686590></div></div><div class=\"banner\" data-v-71686590><h2 data-v-71686590>618智慧生活购精彩</h2><p data-v-71686590>预订最高优惠5200元</p><a href=\"#\" class=\"banner-btn\" data-v-71686590>前往主会场</a></div>", 2)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "category-item",
          key: category.id
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(category.icon), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(category.categeroyName), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title" }, " 新品推荐 ", -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "promo-item",
            key: product.id,
            onClick: ($event: any) => (viewProduct(product))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: product.imgs[0]?.imageUrl,
                height: "120px"
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "promo-tag" }, "新品", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(product.productName), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price), 1)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section-title" }, " 热销商品 ", -1)),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotProducts.value, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "promo-item",
            key: product.id,
            onClick: ($event: any) => (viewProduct(product))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: product.imgs[0]?.imageUrl,
                height: "100px",
                width: "100px"
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(product.productName), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price), 1)
            ])
          ], 8, _hoisted_14))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "section-title" }, " 精选榜单 ", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankingList.value, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ranking-item",
          key: product.id,
          onClick: ($event: any) => (viewProduct(product))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("img", {
              src: product.imgs[0]?.imageUrl,
              height: "100px",
              width: "100px"
            }, null, 8, _hoisted_23)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(product.productName), 1),
            _createElementVNode("div", _hoisted_26, _toDisplayString(product.productsGetSkuDto?.productsSkuInfoDto?.[0]?.price), 1)
          ])
        ], 8, _hoisted_21))
      }), 128))
    ]),
    _createVNode(Layfooter)
  ]))
}
}

})